var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 13.3,
    rx: 2.5,
    fill: "white",
    stroke: "#434341"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.908 9.27743L7.96682 7.37988L5.5 11.3647H17.2648L13.8492 5.38745L10.908 9.27743Z",
    fill: "#434341"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34639 5.38736C8.92278 5.38736 9.39004 4.9201 9.39004 4.3437C9.39004 3.76731 8.92278 3.30005 8.34639 3.30005C7.76999 3.30005 7.30273 3.76731 7.30273 4.3437C7.30273 4.9201 7.76999 5.38736 8.34639 5.38736Z",
    fill: "#434341"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSmall);
export default __webpack_public_path__ + "static/media/img-small.0058717114ce4e2dfac576f0a777157c.svg";
export { ForwardRef as ReactComponent };